import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';

type Props = {
  hasLine: Boolean;
};

export const Spacer = ({ hasLine }: Props) => {
  return (
    <Outer hasLine={hasLine}>
      <Line hasLine={hasLine} />
    </Outer>
  );
};

const Outer = styled.div`
  padding: ${(props: Props) => (props.hasLine ? `25px 0` : `30px 0`)};
  width: 100%;
`;

const Line = styled.div`
  border: ${(props: Props) =>
    props.hasLine ? `1px solid ${Colors.grey200}` : `none`};
`;
